import PropTypes from 'prop-types'
import { liveGifDate } from 'shared/util/date'
import { getEmbedCode } from 'shared/util/gif-embed'
import GifShare from 'shared/components/gif-share'
import css from './list-item-info.css'

const Header = ({ date, gif, isLive, onSocialClick }) => {
    return (
        <div className={css.header}>
            <div className={css.headerInfo}>
                <div className={isLive ? css.dateLive : css.datePast}>
                    <i className={css.clock} /> {liveGifDate(date)}
                </div>
                {/* <h3 className={css.title}></h3> */}
            </div>
            <GifShare gif={gif} css={css} onShare={onSocialClick} />
        </div>
    )
}

const Embed = ({ gif }) => (
    <div className={css.container}>
        <span className={css.link}>Link</span>
        <div className={css.embed}>
            <input
                type="text"
                className={css.input}
                spellCheck={false}
                readOnly={true}
                defaultValue={gif.url}
                data-copy="true"
            />
        </div>
        <span className={css.iframe}>Embed</span>
        <div className={css.embed}>
            <input
                type="text"
                className={css.input}
                spellCheck={false}
                readOnly={true}
                defaultValue={getEmbedCode(gif)}
                data-copy="true"
            />
        </div>
    </div>
)

const ListItemInfo = ({ date, gif, isLive, onSocialClick }) => (
    <div className={css.info}>
        <Header gif={gif} date={date} isLive={isLive} onSocialClick={onSocialClick} />
        <Embed gif={gif} />
    </div>
)

ListItemInfo.propTypes = {
    gif: PropTypes.object,
    date: PropTypes.string,
    isLive: PropTypes.bool,
    onSocialClick: PropTypes.func,
}

export default ListItemInfo
